import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY            || "AIzaSyBNG3Dc-01RakJgSXMceNkn8YTzpgG-B3k",
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN        || "higgins-site2scope.firebaseapp.com",
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID         || "higgins-site2scope",
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET     || "higgins-site2scope.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID|| "109040353041",
  appId:             process.env.REACT_APP_FIREBASE_APP_ID             || "1:109040353041:web:6c85ce16b553dc19cc96b0",
};

const app = initializeApp(firebaseConfig);
export const db      = getFirestore(app);
export const storage = getStorage(app);
export const auth    = getAuth(app);

// ── MICROSOFT ENTRA ID SWAP (Sprint 1 → production) ─────────────────────────
// Once IT registers Site2Scope in the company's Entra ID tenant:
//
//   1. In Firebase Console → Authentication → Sign-in method:
//        • Disable Google provider
//        • Enable Microsoft provider
//        • Paste Client ID and Client Secret from Azure App Registration
//
//   2. In AuthContext.js, replace the Google sign-in block with:
//
//        import { OAuthProvider } from 'firebase/auth';
//        const provider = new OAuthProvider('microsoft.com');
//        provider.setCustomParameters({
//          tenant: 'YOUR_ENTRA_TENANT_ID',   // IT provides this from Azure portal
//        });
//        await signInWithPopup(auth, provider);
//
//   3. No other files change. All currentUser.uid references, Firestore user
//      docs, role logic, and session lock names stay identical.
// ────────────────────────────────────────────────────────────────────────────
